import React from 'react'
import { Button, Space } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'

type BooleanCheckboxProps = {
  value?: boolean
  onChange?: (val?: boolean) => void
  className?: string
  disabled?: boolean
  trueText?: string
  falseText?: string
}

export const BooleanCheckbox: React.FC<BooleanCheckboxProps> = ({
  value,
  onChange,
  className,
  disabled,
  trueText = 'Yes',
  falseText = 'No',
}) => {
  return (
    <Space.Compact className={cn('w-full max-w-[80px]', className)}>
      <Button
        onClick={() => onChange?.(true)}
        {...(value === true ? { type: 'primary' } : {})}
        className={cn('w-1/2', {
          'disabled:bg-blue-100': value === true,
        })}
        disabled={disabled}
      >
        {trueText}
      </Button>
      <Button
        onClick={() => onChange?.(false)}
        {...(value === false ? {
          type: 'primary',
          danger: true,
        } : {})}
        className={cn('w-1/2', {
          'disabled:bg-red-100': value === false,
        })}
        disabled={disabled}
      >
        {falseText}
      </Button>
    </Space.Compact>
  )
}

type AntdFormBooleanProps = {
  className?: string
  disabled?: boolean
  trueText?: string
  falseText?: string
} & AntdFormItemProps

export const AntdFormBoolean: React.FC<AntdFormBooleanProps> = ({
  fieldProps,
  className,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps} normalize={values => !!values}>
      <BooleanCheckbox {...props} className={cn(className)} />
    </AntdFormItem>
  )
}
